import ProfileDialog from './profileDialog.container';

export default ProfileDialog;
